import React, { useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";

import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";

function Password() {
  const { user } = useContext(AuthContext);
  const URL_SIGNUP_EDIT = `${process.env.REACT_APP_URL_USERS}/passwordUser/${user.id}`;
  const [passwordActual, setPasswordActual] = useState("");
  const [passwordNuevo, setPasswordNuevo] = useState("");
  const [passwordVerificar, setPasswordVerificar] = useState("");

  function cambiarPassword() {
      if(passwordNuevo == passwordVerificar){
        axios
        .patch(
          URL_SIGNUP_EDIT,
          {
            email: user.email,
            password: passwordActual,
            passwordNuevo,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          clear();
          Swal.fire("Good job!", "Creado con exito", "success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: error.response?.data?.message || "Ocurrió un error, intenta de nuevo.",
          });
          console.log(error);
        });
    }else Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La nueva contraseña no coincide",
        // footer: `${error.response.data}`,
      });
      }
    

  const clear = () => {
    setPasswordActual("");
    setPasswordNuevo("");
    setPasswordVerificar("");
  };

  return (
    <>
      <Label>Password Anterior</Label>
      <Input
        value={passwordActual}
        onChange={(e) => setPasswordActual(e.target.value)}
        type="password"
        placeholder="Password Actual"
        required
      />
      <Label>Password Nuevo</Label>
      <Input
      required
        value={passwordNuevo}
        onChange={(e) => setPasswordNuevo(e.target.value)}
        type="password"
        placeholder="Password Nuevo"
      />
      <Label>Ingresa Nuevamente</Label>
      <Input
        value={passwordVerificar}
        onChange={(e) => setPasswordVerificar(e.target.value)}
        type="password"
        placeholder="Verificar Password"
        required
      />
      <Button onClick={cambiarPassword}>Guardar</Button>
    </>
  );
}

export default Password;
